import type { PublicAttribute } from 'src/redux/product/types';

export interface UIPublicAttribute {
  key: string;
  title: string;
  values: string[];
}

const formatValue = (value: string | number | boolean | null): string | null => {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  if (value === null) {
    return null;
  }

  return String(value);
};

const excludedPublicAttributesKeys = new Set([
  'attributes.star_brand',
  'attributes.highly_rated',
  'attributes.pim_exclusive',
  'attributes.pim_returnable',
  'attributes.pim_made_in_britain',
]);

export const adaptPublicAttributesToUI = (
  publicAttributes: PublicAttribute[],
): UIPublicAttribute[] => {
  return publicAttributes.flatMap((attribute) => {
    if (excludedPublicAttributesKeys.has(attribute.key)) {
      return [];
    }

    const values = attribute.values.flatMap((value) => {
      const formatted = formatValue(value);
      return formatted !== null ? [formatted] : [];
    });

    return values.length > 0 ? [{ key: attribute.key, title: attribute.title, values }] : [];
  });
};
